module.exports = __webpack_public_path__ + "img/res8.ea50c8ea.jpg";